import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.3533 4.89549C11.5974 4.6514 11.9931 4.65137 12.2372 4.89543L15.0176 7.67538C15.2617 7.91944 15.2617 8.31516 15.0176 8.55926C14.7736 8.80336 14.3778 8.80338 14.1338 8.55932L11.3534 5.77938C11.1093 5.53532 11.1093 5.13959 11.3533 4.89549Z",
      fill: "#0F171F"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.625 3.29169C14.5876 3.29169 14.5368 3.30543 14.4836 3.35863L3.40027 14.442C3.35384 14.4884 3.34386 14.51 3.34197 14.5143C3.34086 14.5167 3.33333 14.533 3.33333 14.5834V16.7084H5.375C5.42538 16.7084 5.44148 16.7009 5.44388 16.6998C5.44815 16.6979 5.46995 16.6878 5.51639 16.6414L16.5997 5.55808C16.6529 5.50488 16.6667 5.45404 16.6667 5.41669C16.6667 5.37933 16.6529 5.32849 16.5997 5.2753L16.59 5.26537L14.7627 3.35504C14.7109 3.30481 14.6615 3.29169 14.625 3.29169ZM13.5997 2.47475C14.1771 1.89733 15.0729 1.89733 15.6503 2.47475L15.66 2.48467L17.4891 4.39692C18.061 4.97451 18.0592 5.86638 17.4836 6.44196L6.40027 17.5253C6.28004 17.6455 6.13498 17.7606 5.95175 17.842C5.76581 17.9246 5.57293 17.9584 5.375 17.9584H2.70833C2.36316 17.9584 2.08333 17.6785 2.08333 17.3334V14.5834C2.08333 14.3854 2.11706 14.1925 2.1997 14.0066C2.28114 13.8234 2.39616 13.6783 2.51639 13.5581L13.5997 2.47475Z",
      fill: "#0F171F"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.21364 0.25C4.21364 1.81481 5.71364 3.34259 7.25 3.34259V4.28704C5.71364 4.28704 4.21364 5.68519 4.21364 7.25H3.28636C3.28636 5.68519 1.78636 4.28704 0.25 4.28704V3.34259C1.78636 3.34259 3.28636 1.81481 3.28636 0.25H4.21364Z",
      fill: "var(--magic)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.7136 12.75C16.7136 14.3148 18.2136 15.8426 19.75 15.8426V16.787C18.2136 16.787 16.7136 18.1852 16.7136 19.75H15.7864C15.7864 18.1852 14.2864 16.787 12.75 16.787V15.8426C14.2864 15.8426 15.7864 14.3148 15.7864 12.75H16.7136Z",
      fill: "var(--magic)"
    }, null, -1)
  ])))
}
export default { render: render }